import { render, staticRenderFns } from "./PaymentCardSetup.vue?vue&type=template&id=0f38742e&"
import script from "./PaymentCardSetup.vue?vue&type=script&lang=js&"
export * from "./PaymentCardSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports